module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.17128"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.17128"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39280",
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};